var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMinusIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 12.9746H5.8125q-.4921 0-.8086-.3164t-.3164-.8086q0-.4922.3164-.8086t.8086-.3164h12.375q.4922 0 .8086.3164t.3164.8086-.3164.8086-.8086.3164"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMinusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/minus-icon.ef4c972ef68b3e234e69e89cded98a12.svg";